import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class WorkSchedulerPaths {
  static workScheduler = new EnhancedPath('/work-scheduler');
  static workSchedulerByState = new EnhancedPath(`${WorkSchedulerPaths.workScheduler.path}/state`);
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: WorkSchedulerPaths.workSchedulerByState.path,
      component: lazyWithRetry(() => import('app/pages/system/workScheduler/summary')),
      pageCode: PAGE_CODES.WORK_SCHEDULER_BY_STATE,
    },
    {
      path: WorkSchedulerPaths.workScheduler.path,
      component: lazyWithRetry(() => import('app/pages/system/workScheduler')),
      pageCode: PAGE_CODES.WORK_SCHEDULER,
    },
  ],
};

export default routesConfig;
